import React from 'react';
import ProjectCard from '../components/ProjectCard';
import './Portfolio.css';

function Portfolio() {
  const projects = [
    { type: 'video', media: '/Portfolio/LivingRoom.mp4', title: 'Modern Living Room', description: 'A sleek modern design.' },
    { type: 'video', media: '/Portfolio/ModularKitchen.mp4', title: 'Modular Kitchen', description: 'Timeless and elegant.' },
    { type: 'video', media: '/Portfolio/Temple.mp4', title: 'Sacred Temple', description: 'Highlights the spiritual and revered nature of the place.' },
    { type: 'video', media: '/Portfolio/BedRoom.mp4', title: 'Elegant Bedroom', description: 'Sophisticated and stylish.' },
  ];

  return (
    <div className="portfolio">
      <h1>Our Portfolio</h1>
      <div className="project-grid">
        {projects.map((project, index) => (
          <ProjectCard key={index} {...project} />
        ))}
      </div>
    </div>
  );
}

export default Portfolio;